import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import {
    ADD_CRM_NOTE,
    CREATE_CRM_ACCOUNT,
    DELETE_CRM_ACCOUNT,
    DELETE_CRM_NOTE,
    EDIT_CRM_NOTE,
    LINK_CRM_ACCOUNT_BUSINESS,
    MARK_CRM_ACCOUNT_DUPLICATE,
    MERGE_CRM_ACCOUNTS,
    MOVE_CRM_ACCOUNT_STAGE,
    REQUEST_BUSINESS_LOGIN,
    SET_CRM_ACCOUNT_POGOZO_DEMO,
    SET_CRM_ACCOUNT_REPORTING_EXCLUDED,
    UPDATE_CRM_ACCOUNT,
    VERIFY_BUSINESS_LOGIN
} from 'grapqhl/crm/account/mutations';
import {
    CRM_BUSINESS_DETAIL_OPTIONS,
    EXPORT_CRM_BOARD,
    GET_BUSINESS_LOGIN_LOG_FOR_BUSINESS,
    GET_CRM_ACCOUNT,
    GET_CRM_BOARD,
    LIST_CRM_ACCOUNTS,
    LIST_CRM_DUPLICATE_GROUPS,
    SUGGESTED_CRM_ACCOUNT_DUPLICATES
} from 'grapqhl/crm/account/queries';
import { REQUEST_FORCE_DELETE, REQUEST_STATUS_CHANGE, VERIFY_FORCE_DELETE, VERIFY_STATUS_CHANGE } from 'grapqhl/businessStatus/mutations';
import { CREATE_CRM_AUDIENCE, DELETE_CRM_AUDIENCE, UPDATE_CRM_AUDIENCE } from 'grapqhl/crm/audience/mutations';
import {
    GET_CRM_AUDIENCE,
    LIST_CRM_AUDIENCE_MEMBER_COUNTS,
    LIST_CRM_AUDIENCES,
    LIST_CRM_BOARD_STAGE_LABELS,
    PREVIEW_CRM_AUDIENCE
} from 'grapqhl/crm/audience/queries';
import {
    CREATE_CRM_AUTOMATION,
    DELETE_CRM_AUTOMATION,
    DUPLICATE_CRM_AUTOMATION,
    ENROL_CRM_IN_AUTOMATION,
    TEST_CRM_AUTOMATION,
    UPDATE_CRM_AUTOMATION
} from 'grapqhl/crm/automation/mutations';
import { LIST_CRM_AUTOMATIONS } from 'grapqhl/crm/automation/queries';
import { CRM_ASSIGNABLE_STAFF } from 'grapqhl/crm/staff/queries';
import {
    ADD_CRM_CAMPAIGN_RECIPIENT,
    SEND_CRM_CAMPAIGN_TO_TARGET,
    CREATE_CRM_CAMPAIGN,
    DELETE_CRM_CAMPAIGN,
    SCHEDULE_CRM_CAMPAIGN,
    SEND_CRM_CAMPAIGN_NOW,
    SEND_CRM_TEST_EMAIL,
    UPDATE_CRM_CAMPAIGN
} from 'grapqhl/crm/campaign/mutations';
import { GET_CRM_CAMPAIGN, GET_CRM_CAMPAIGN_RECIPIENTS, LIST_CRM_CAMPAIGNS } from 'grapqhl/crm/campaign/queries';
import {
    CREATE_CRM_BOARD,
    CREATE_CRM_PIPELINE,
    DELETE_CRM_BOARD,
    PLACE_CRM_AUTOMATION,
    PLACE_CRM_ON_BOARD,
    REORDER_CRM_BOARDS,
    REORDER_CRM_PIPELINES,
    SET_CRM_BOARD_STATUS,
    UPDATE_CRM_BOARD,
    UPDATE_CRM_BOARD_PIPELINE
} from 'grapqhl/crm/board/mutations';
import { GET_CRM_JOURNEY_BOARD, LIST_AUTOMATION_ENROLLMENTS, LIST_CRM_BOARDS } from 'grapqhl/crm/board/queries';
import {
    ARCHIVE_CRM_MEETING_TYPE,
    CANCEL_CRM_MEETING,
    CANCEL_CRM_MEETING_SERIES,
    PLACE_CRM_MEETING,
    REPLACE_CRM_MEETING,
    SAVE_CRM_CALENDAR_SETTINGS,
    RESCHEDULE_CRM_MEETING,
    SET_CRM_MEETING_NOTE,
    UPDATE_CRM_MEETING_ATTENDEES,
    CREATE_CRM_BOOKING_LINK,
    CREATE_CRM_MEETING_TYPE,
    DELETE_CRM_BOOKING_LINK,
    DELETE_CRM_MEETING_TYPE,
    CREATE_CRM_ADMIN_BLOCK,
    DELETE_CRM_ADMIN_BLOCK,
    DELETE_CRM_ADMIN_BLOCK_SERIES,
    UPDATE_CRM_ADMIN_BLOCK,
    DISCONNECT_CRM_BOOKING_GOOGLE,
    MARK_CRM_MEETING_ATTENDANCE,
    SAVE_CRM_SCHEDULE_FOR_ADMIN,
    SAVE_MY_CRM_SCHEDULE,
    UPDATE_CRM_BOOKING_LINK,
    UPDATE_CRM_MEETING_TYPE
} from 'grapqhl/crm/calendar/mutations';
import {
    GET_CRM_BOOKING_GOOGLE_AUTH_URL,
    GET_CRM_BOOKING_GOOGLE_CONNECTION,
    GET_CRM_SCHEDULE_FOR_ADMIN,
    GET_MY_CRM_SCHEDULE,
    LIST_CRM_ADMIN_BLOCKS,
    LIST_CRM_BOOKING_LINKS,
    LIST_CRM_MEETING_HOSTS,
    LIST_CRM_MEETING_TYPES,
    LIST_CRM_SCHEDULES,
    LIST_CRM_MEETINGS,
    LIST_CRM_MEETINGS_IN_RANGE,
    LIST_CRM_GOOGLE_EVENTS,
    GET_CRM_CALENDAR_SETTINGS
} from 'grapqhl/crm/calendar/queries';
import {
    ADD_CRM_CONTACT_NOTE,
    CREATE_CRM_CONTACT,
    DELETE_CRM_CONTACT,
    SET_CRM_CONTACT_EMAIL_SUBSCRIBED,
    SET_PRIMARY_CRM_CONTACT,
    UPDATE_CRM_CONTACT,
    SET_CRM_CONTACT_NOTE_PINNED
} from 'grapqhl/crm/contact/mutations';
import { GET_CRM_CONTACT_PROFILE, LIST_ALL_CRM_CONTACTS, LIST_CRM_CONTACT_NOTES, LIST_CRM_CONTACTS } from 'grapqhl/crm/contact/queries';
import { SAVE_CRM_EMAIL_SETTINGS, SEND_CRM_EMAIL } from 'grapqhl/crm/email/mutations';
import { GET_CRM_EMAIL_SETTINGS, LIST_CRM_ACCOUNT_EMAILS } from 'grapqhl/crm/email/queries';
import {
    CREATE_CRM_EMAIL_TEMPLATE,
    DELETE_CRM_EMAIL_TEMPLATE,
    DUPLICATE_CRM_EMAIL_TEMPLATE,
    SEND_CRM_TEMPLATE_TEST_EMAIL,
    UPDATE_CRM_EMAIL_TEMPLATE
} from 'grapqhl/crm/emailTemplate/mutations';
import { CRM_MERGE_TAGS, GET_CRM_EMAIL_TEMPLATE, LIST_CRM_EMAIL_TEMPLATES } from 'grapqhl/crm/emailTemplate/queries';
import {
    ARCHIVE_CRM_CONTRACT_TEMPLATE,
    CREATE_CRM_CONTRACT_TEMPLATE,
    UPDATE_CRM_CONTRACT_TEMPLATE
} from 'grapqhl/crm/contractTemplate/mutations';
import { GET_CRM_CONTRACT_TEMPLATE_DETAILS, LIST_CRM_CONTRACT_TEMPLATES } from 'grapqhl/crm/contractTemplate/queries';
import { CREATE_CRM_CONTRACT, SEND_CRM_CONTRACT } from 'grapqhl/crm/contract/mutations';
import { GET_CRM_CONTRACT_DETAILS, GET_CRM_CONTRACT_SIGNED_PDF_URL, LIST_CRM_CONTRACTS } from 'grapqhl/crm/contract/queries';
import { CREATE_CRM_FORM, DELETE_CRM_FORM, UPDATE_CRM_FORM } from 'grapqhl/crm/form/mutations';
import { LIST_CRM_FORMS, LIST_CRM_FORM_SUBMISSIONS } from 'grapqhl/crm/form/queries';
import { IMPORT_PIPEDRIVE_CSV } from 'grapqhl/crm/import/mutations';
import { PREVIEW_PIPEDRIVE_CSV } from 'grapqhl/crm/import/queries';
import { IMPORT_CONTACTS_CSV } from 'grapqhl/crm/contact-import/mutations';
import { PREVIEW_CONTACTS_CSV } from 'grapqhl/crm/contact-import/queries';
import { CREATE_CRM_LEAD_SOURCE, DELETE_CRM_LEAD_SOURCE, RENAME_CRM_LEAD_SOURCE } from 'grapqhl/crm/leadSource/mutations';
import { GET_CRM_LEAD_SOURCES } from 'grapqhl/crm/leadSource/queries';
import { CRM_STAGE_CONVERSION, CRM_WIN_LOSS_BY_OWNER } from 'grapqhl/crm/reporting/queries';
import { UPDATE_CRM_PIPELINE } from 'grapqhl/crm/stage/mutations';
import { GET_CRM_PIPELINE, LIST_CRM_PIPELINES } from 'grapqhl/crm/stage/queries';
import { CREATE_CRM_TAG, DELETE_CRM_TAG, RENAME_CRM_TAG } from 'grapqhl/crm/tag/mutations';
import { GET_CRM_TAGS } from 'grapqhl/crm/tag/queries';
import { COMPLETE_CRM_TASK, CREATE_CRM_TASK, DELETE_CRM_TASK, UPDATE_CRM_TASK } from 'grapqhl/crm/task/mutations';
import { LIST_CRM_TASKS } from 'grapqhl/crm/task/queries';
import {
    AddCrmNoteInput,
    AddCrmNoteResponse,
    AddCrmContactNoteInput,
    AddCrmContactNoteResponse,
    CancelCrmMeetingResponse,
    PlaceCrmMeetingInput,
    PlaceCrmMeetingResponse,
    ReplaceCrmMeetingInput,
    ReplaceCrmMeetingResponse,
    RescheduleCrmMeetingResponse,
    SetCrmMeetingNoteResponse,
    UpdateCrmMeetingAttendeesInput,
    UpdateCrmMeetingAttendeesResponse,
    CompleteCrmTaskResponse,
    CreateCrmAccountInput,
    CreateCrmAccountResponse,
    DeleteCrmAccountResponse,
    CreateCrmAudienceInput,
    CreateCrmAudienceResponse,
    AddCrmCampaignRecipientInput,
    AddCrmCampaignRecipientResponse,
    SendCrmCampaignTargetInput,
    SendCrmCampaignToTargetResponse,
    CreateCrmCampaignInput,
    CreateCrmCampaignResponse,
    CreateCrmAutomationInput,
    CreateCrmAutomationResponse,
    TestCrmAutomationInput,
    TestCrmAutomationResponse,
    DuplicateCrmAutomationInput,
    DuplicateCrmAutomationResponse,
    DuplicateCrmEmailTemplateInput,
    DuplicateCrmEmailTemplateResponse,
    ArchiveCrmContractTemplateResponse,
    CreateCrmContractTemplateInput,
    CreateCrmContractTemplateResponse,
    GetCrmContractTemplateResponse,
    ListCrmContractTemplatesInput,
    ListCrmContractTemplatesResponse,
    UpdateCrmContractTemplateInput,
    UpdateCrmContractTemplateResponse,
    CreateCrmContractInput,
    CreateCrmContractResponse,
    GetCrmContractResponse,
    GetCrmContractSignedPdfUrlResponse,
    ListCrmContractsInput,
    ListCrmContractsResponse,
    SendCrmContractResponse,
    CreateCrmContactInput,
    CreateCrmContactResponse,
    CreateCrmEmailTemplateInput,
    CreateCrmEmailTemplateResponse,
    CreateCrmFormInput,
    CreateCrmFormResponse,
    CreateCrmTaskInput,
    CreateCrmTaskResponse,
    CrmAccountFilterInput,
    CreateCrmBoardInput,
    CreateCrmBoardResponse,
    CreateCrmPipelineInput,
    CreateCrmPipelineResponse,
    DeleteCrmBoardResponse,
    GetCrmJourneyBoardResponse,
    ListAutomationEnrollmentsResponse,
    ListCrmBoardsResponse,
    PlaceCrmAutomationInput,
    PlaceCrmAutomationResponse,
    PlaceCrmOnBoardInput,
    PlaceCrmOnBoardResponse,
    EnrolCrmInAutomationInput,
    EnrolCrmInAutomationResponse,
    ReorderCrmBoardsInput,
    ReorderCrmBoardsResponse,
    ReorderCrmPipelinesInput,
    ReorderCrmPipelinesResponse,
    SetCrmBoardStatusResponse,
    UpdateCrmBoardInput,
    UpdateCrmBoardPipelineInput,
    UpdateCrmBoardPipelineResponse,
    UpdateCrmBoardResponse,
    CreateCrmTagInput,
    CreateCrmTagResponse,
    DeleteCrmTagInput,
    DeleteCrmTagResponse,
    GetCrmTagsResponse,
    RenameCrmTagInput,
    RenameCrmTagResponse,
    CreateCrmLeadSourceInput,
    CreateCrmLeadSourceResponse,
    DeleteCrmLeadSourceInput,
    DeleteCrmLeadSourceResponse,
    GetCrmLeadSourcesResponse,
    RenameCrmLeadSourceInput,
    RenameCrmLeadSourceResponse,
    CrmAudienceFiltersInput,
    CrmReportFilterInput,
    CrmStageConversionResponse,
    CrmWinLossByOwnerResponse,
    DeleteCrmAudienceResponse,
    DeleteCrmCampaignResponse,
    DeleteCrmAutomationResponse,
    DeleteCrmContactResponse,
    DeleteCrmEmailTemplateResponse,
    DeleteCrmFormResponse,
    DeleteCrmNoteInput,
    DeleteCrmNoteResponse,
    DeleteCrmTaskResponse,
    CrmTaskScopeOption,
    EditCrmNoteInput,
    EditCrmNoteResponse,
    ExportCrmBoardResponse,
    GetCrmAccountResponse,
    GetCrmAudienceResponse,
    GetCrmCampaignResponse,
    GetCrmContactProfileResponse,
    GetCrmCampaignRecipientsResponse,
    GetCrmBoardResponse,
    GetCrmBookingGoogleAuthUrlResponse,
    GetCrmBookingGoogleConnectionResponse,
    DisconnectCrmBookingGoogleResponse,
    GetMyCrmScheduleResponse,
    SaveMyCrmScheduleResponse,
    SaveCrmScheduleInput,
    GetCrmScheduleForAdminResponse,
    ListCrmSchedulesResponse,
    SaveCrmScheduleForAdminResponse,
    ListCrmAdminBlocksResponse,
    CreateCrmAdminBlockInput,
    CreateCrmAdminBlockResponse,
    UpdateCrmAdminBlockInput,
    UpdateCrmAdminBlockResponse,
    DeleteCrmAdminBlockResponse,
    ListCrmMeetingTypesResponse,
    ListCrmMeetingHostsResponse,
    ListCrmAssignableStaffResponse,
    CreateCrmMeetingTypeInput,
    CreateCrmMeetingTypeResponse,
    UpdateCrmMeetingTypeInput,
    UpdateCrmMeetingTypeResponse,
    ArchiveCrmMeetingTypeResponse,
    DeleteCrmMeetingTypeResponse,
    ListCrmBookingLinksResponse,
    CreateCrmBookingLinkInput,
    CreateCrmBookingLinkResponse,
    UpdateCrmBookingLinkInput,
    UpdateCrmBookingLinkResponse,
    DeleteCrmBookingLinkResponse,
    GetCrmPipelineResponse,
    GetCrmEmailTemplateResponse,
    ImportPipedriveCsvInput,
    ImportPipedriveCsvResponse,
    ImportContactsCsvInput,
    ImportContactsCsvResponse,
    PreviewContactsCsvInput,
    PreviewContactsCsvResponse,
    ListCrmAccountEmailsResponse,
    LinkCrmAccountBusinessInput,
    LinkCrmAccountBusinessResponse,
    SetCrmAccountPogozoDemoResponse,
    SetPogozoDemoInput,
    SetCrmAccountReportingExcludedInput,
    SetCrmAccountReportingExcludedResponse,
    CrmBusinessDetailOptionsResponse,
    ListAllCrmContactsInput,
    ListAllCrmContactsResponse,
    ListCrmAccountsInput,
    ListCrmAccountsResponse,
    ListCrmAudiencesResponse,
    ListCrmAudienceMemberCountsResponse,
    ListCrmBoardStageLabelsResponse,
    ListCrmCampaignsResponse,
    ListCrmAutomationsResponse,
    ListCrmMeetingsResponse,
    MeetingScope,
    ListCrmMeetingsInRangeResponse,
    ListCrmGoogleEventsResponse,
    GetCrmCalendarSettingsResponse,
    SaveCrmCalendarSettingsInput,
    SaveCrmCalendarSettingsResponse,
    GetCrmEmailSettingsResponse,
    SaveCrmEmailSettingsInput,
    SaveCrmEmailSettingsResponse,
    MarkCrmMeetingAttendanceResponse,
    ListCrmContactsResponse,
    ListCrmContactNotesInput,
    ListCrmContactNotesResponse,
    ListCrmEmailTemplatesResponse,
    CrmMergeTagsResponse,
    ListCrmFormsResponse,
    ListCrmFormSubmissionsResponse,
    ListCrmPipelinesResponse,
    ListCrmTasksInput,
    ListCrmTasksResponse,
    MarkCrmAccountDuplicateInput,
    MarkCrmAccountDuplicateResponse,
    MergeCrmAccountsInput,
    MergeCrmAccountsResponse,
    MoveCrmAccountStageInput,
    MoveCrmAccountStageResponse,
    PreviewCrmAudienceResponse,
    PreviewPipedriveCsvInput,
    PreviewPipedriveCsvResponse,
    ScheduleCrmCampaignInput,
    ScheduleCrmCampaignResponse,
    SendCrmCampaignNowResponse,
    SendCrmEmailInput,
    SendCrmEmailResponse,
    SendCrmTestEmailInput,
    SendCrmTestEmailResponse,
    SendCrmTemplateTestEmailInput,
    SendCrmTemplateTestEmailResponse,
    SetCrmContactEmailSubscribedResponse,
    SetPrimaryCrmContactResponse,
    SetCrmContactNotePinnedInput,
    SetCrmContactNotePinnedResponse,
    SuggestedCrmAccountDuplicatesResponse,
    ListCrmDuplicateGroupsInput,
    ListCrmDuplicateGroupsResponse,
    UpdateCrmAccountInput,
    UpdateCrmAccountResponse,
    UpdateCrmAudienceInput,
    UpdateCrmAudienceResponse,
    UpdateCrmCampaignInput,
    UpdateCrmCampaignResponse,
    UpdateCrmAutomationInput,
    UpdateCrmAutomationResponse,
    UpdateCrmContactInput,
    UpdateCrmContactResponse,
    UpdateCrmEmailTemplateInput,
    UpdateCrmEmailTemplateResponse,
    UpdateCrmFormInput,
    UpdateCrmFormResponse,
    UpdateCrmPipelineInput,
    UpdateCrmPipelineResponse,
    UpdateCrmTaskInput,
    UpdateCrmTaskResponse
} from 'types/crm';

export const useGQL = () => {
    /* pipeline stages (settings) */
    const GET_PIPELINE = () => useQuery<GetCrmPipelineResponse>(GET_CRM_PIPELINE, { notifyOnNetworkStatusChange: true });

    const LIST_PIPELINES = () =>
        useQuery<ListCrmPipelinesResponse>(LIST_CRM_PIPELINES, {
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const UPDATE_PIPELINE = () => useMutation<UpdateCrmPipelineResponse, { input: UpdateCrmPipelineInput }>(UPDATE_CRM_PIPELINE);

    /* managed tags (settings + reusable TagSelect) */
    const GET_TAGS = () => useQuery<GetCrmTagsResponse>(GET_CRM_TAGS, { notifyOnNetworkStatusChange: true });

    const CREATE_TAG = () => useMutation<CreateCrmTagResponse, { input: CreateCrmTagInput }>(CREATE_CRM_TAG);

    const RENAME_TAG = () => useMutation<RenameCrmTagResponse, { input: RenameCrmTagInput }>(RENAME_CRM_TAG);

    const DELETE_TAG = () => useMutation<DeleteCrmTagResponse, { input: DeleteCrmTagInput }>(DELETE_CRM_TAG);

    /* managed lead sources (settings + reusable LeadSourceSelect) — mirrors managed tags */
    const GET_LEAD_SOURCES = () => useQuery<GetCrmLeadSourcesResponse>(GET_CRM_LEAD_SOURCES, { notifyOnNetworkStatusChange: true });

    const CREATE_LEAD_SOURCE = () => useMutation<CreateCrmLeadSourceResponse, { input: CreateCrmLeadSourceInput }>(CREATE_CRM_LEAD_SOURCE);

    const RENAME_LEAD_SOURCE = () => useMutation<RenameCrmLeadSourceResponse, { input: RenameCrmLeadSourceInput }>(RENAME_CRM_LEAD_SOURCE);

    const DELETE_LEAD_SOURCE = () => useMutation<DeleteCrmLeadSourceResponse, { input: DeleteCrmLeadSourceInput }>(DELETE_CRM_LEAD_SOURCE);

    /* customer-journey boards + multi-pipeline (Phase 5) */
    const LIST_BOARDS = () =>
        useQuery<ListCrmBoardsResponse>(LIST_CRM_BOARDS, {
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const GET_JOURNEY_BOARD = (boardId: string) =>
        useQuery<GetCrmJourneyBoardResponse, { boardId: string }>(GET_CRM_JOURNEY_BOARD, {
            variables: { boardId },
            skip: !boardId,
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const LIST_ENROLLMENTS = (automationId: string, status?: string) =>
        useQuery<ListAutomationEnrollmentsResponse, { automationId: string; status?: string }>(LIST_AUTOMATION_ENROLLMENTS, {
            variables: { automationId, status },
            skip: !automationId,
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const CREATE_BOARD = () => useMutation<CreateCrmBoardResponse, { input: CreateCrmBoardInput }>(CREATE_CRM_BOARD);

    const UPDATE_BOARD = () => useMutation<UpdateCrmBoardResponse, { input: UpdateCrmBoardInput }>(UPDATE_CRM_BOARD);

    const REORDER_BOARDS = () => useMutation<ReorderCrmBoardsResponse, { input: ReorderCrmBoardsInput }>(REORDER_CRM_BOARDS);

    const SET_BOARD_STATUS = () =>
        useMutation<SetCrmBoardStatusResponse, { boardId: string; status: 'active' | 'inactive' }>(SET_CRM_BOARD_STATUS);

    const DELETE_BOARD = () => useMutation<DeleteCrmBoardResponse, { boardId: string }>(DELETE_CRM_BOARD);

    const CREATE_PIPELINE = () => useMutation<CreateCrmPipelineResponse, { input: CreateCrmPipelineInput }>(CREATE_CRM_PIPELINE);

    const UPDATE_BOARD_PIPELINE = () =>
        useMutation<UpdateCrmBoardPipelineResponse, { input: UpdateCrmBoardPipelineInput }>(UPDATE_CRM_BOARD_PIPELINE);

    const REORDER_PIPELINES = () => useMutation<ReorderCrmPipelinesResponse, { input: ReorderCrmPipelinesInput }>(REORDER_CRM_PIPELINES);

    const PLACE_AUTOMATION = () => useMutation<PlaceCrmAutomationResponse, { input: PlaceCrmAutomationInput }>(PLACE_CRM_AUTOMATION);

    const PLACE_ON_BOARD = () => useMutation<PlaceCrmOnBoardResponse, { input: PlaceCrmOnBoardInput }>(PLACE_CRM_ON_BOARD);

    /* board / accounts */
    const GET_BOARD = (filter?: CrmAccountFilterInput) =>
        useQuery<GetCrmBoardResponse, { filter?: CrmAccountFilterInput }>(GET_CRM_BOARD, {
            variables: { filter },
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const LIST_ACCOUNTS = (input: ListCrmAccountsInput, skip = false) =>
        useQuery<ListCrmAccountsResponse, { input: ListCrmAccountsInput }>(LIST_CRM_ACCOUNTS, {
            variables: { input },
            skip,
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const LIST_ACCOUNTS_LAZY = () => useLazyQuery<ListCrmAccountsResponse, { input: ListCrmAccountsInput }>(LIST_CRM_ACCOUNTS);

    /* onboarding-sourced option lists for the business-details form (Wave 3 Phase 10) */
    const BUSINESS_DETAIL_OPTIONS = () =>
        useQuery<CrmBusinessDetailOptionsResponse>(CRM_BUSINESS_DETAIL_OPTIONS, { fetchPolicy: 'cache-first' });

    const GET_ACCOUNT = (id: string) =>
        useQuery<GetCrmAccountResponse, { id: string }>(GET_CRM_ACCOUNT, {
            variables: { id },
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const CREATE_ACCOUNT = () => useMutation<CreateCrmAccountResponse, { input: CreateCrmAccountInput }>(CREATE_CRM_ACCOUNT);

    const DELETE_ACCOUNT = () => useMutation<DeleteCrmAccountResponse, { accountId: string }>(DELETE_CRM_ACCOUNT);

    const UPDATE_ACCOUNT = () => useMutation<UpdateCrmAccountResponse, { input: UpdateCrmAccountInput }>(UPDATE_CRM_ACCOUNT);

    const MOVE_ACCOUNT_STAGE = () => useMutation<MoveCrmAccountStageResponse, { input: MoveCrmAccountStageInput }>(MOVE_CRM_ACCOUNT_STAGE);

    /* notes */
    const ADD_NOTE = () => useMutation<AddCrmNoteResponse, { input: AddCrmNoteInput }>(ADD_CRM_NOTE);

    const EDIT_NOTE = () => useMutation<EditCrmNoteResponse, { input: EditCrmNoteInput }>(EDIT_CRM_NOTE);

    const DELETE_NOTE = () => useMutation<DeleteCrmNoteResponse, { input: DeleteCrmNoteInput }>(DELETE_CRM_NOTE);

    /* link to Pogozo business */
    const LINK_BUSINESS = () =>
        useMutation<LinkCrmAccountBusinessResponse, { input: LinkCrmAccountBusinessInput }>(LINK_CRM_ACCOUNT_BUSINESS);

    /* mark the linked business as forever-free Pogozo Demo (Wave 3 Phase 2) */
    const SET_POGOZO_DEMO = () => useMutation<SetCrmAccountPogozoDemoResponse, { input: SetPogozoDemoInput }>(SET_CRM_ACCOUNT_POGOZO_DEMO);

    /* flag/unflag an account out of reporting (POGO-13862) — fake/spam/test lead */
    const SET_REPORTING_EXCLUDED = () =>
        useMutation<SetCrmAccountReportingExcludedResponse, { input: SetCrmAccountReportingExcludedInput }>(
            SET_CRM_ACCOUNT_REPORTING_EXCLUDED
        );

    /* CMS team member logging into a linked business (POGO-13282) */
    const REQUEST_BUSINESS_LOGIN_MUTATION = () =>
        useMutation<
            { requestBusinessLogin: { expiresAt?: string; expiresBy?: number } },
            { input: { businessId: string; deviceId: string } }
        >(REQUEST_BUSINESS_LOGIN);

    const VERIFY_BUSINESS_LOGIN_MUTATION = () =>
        useMutation<
            { verifyBusinessLogin: { accessToken: string; businessId: string } },
            { input: { businessId: string; code: string; deviceId: string } }
        >(VERIFY_BUSINESS_LOGIN);

    /* inactivate / reactivate a business via an email OTP step-up (POGO-13731) */
    const REQUEST_STATUS_CHANGE_MUTATION = () =>
        useMutation<
            { requestBusinessStatusChange: { expiresAt?: string; expiresBy?: number } },
            { input: { businessId: string; deviceId: string } }
        >(REQUEST_STATUS_CHANGE);

    const VERIFY_STATUS_CHANGE_MUTATION = () =>
        useMutation<{ verifyBusinessStatusChange: { status: string } }, { input: { businessId: string; code: string; deviceId: string } }>(
            VERIFY_STATUS_CHANGE
        );

    /* Alex-only force-delete of a business with no owner deletion request (POGO-13731 Phase 3) */
    const REQUEST_FORCE_DELETE_MUTATION = () =>
        useMutation<
            { requestForceDelete: { expiresAt?: string; expiresBy?: number } },
            { input: { businessId: string; deviceId: string } }
        >(REQUEST_FORCE_DELETE);

    const VERIFY_FORCE_DELETE_MUTATION = () =>
        useMutation<{ verifyForceDelete: { message: string } }, { input: { businessId: string; code: string; deviceId: string } }>(
            VERIFY_FORCE_DELETE
        );

    /* who from Pogozo has logged into this business (POGO-13282) */
    const GET_BUSINESS_LOGIN_LOG = (input: { businessId: string; skip?: number; limit?: number }, skip = false) =>
        useQuery(GET_BUSINESS_LOGIN_LOG_FOR_BUSINESS, {
            variables: { input },
            skip: skip || !input.businessId,
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true
        });

    /* contacts */
    const LIST_CONTACTS = (accountId: string) =>
        useQuery<ListCrmContactsResponse, { accountId: string }>(LIST_CRM_CONTACTS, {
            variables: { accountId },
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const CREATE_CONTACT = () => useMutation<CreateCrmContactResponse, { input: CreateCrmContactInput }>(CREATE_CRM_CONTACT);

    const UPDATE_CONTACT = () => useMutation<UpdateCrmContactResponse, { input: UpdateCrmContactInput }>(UPDATE_CRM_CONTACT);

    const SET_PRIMARY_CONTACT = () => useMutation<SetPrimaryCrmContactResponse, { contactId: string }>(SET_PRIMARY_CRM_CONTACT);

    const SET_CONTACT_EMAIL_SUBSCRIBED = () =>
        useMutation<SetCrmContactEmailSubscribedResponse, { contactId: string; emailSubscribed: boolean }>(
            SET_CRM_CONTACT_EMAIL_SUBSCRIBED
        );

    const DELETE_CONTACT = () => useMutation<DeleteCrmContactResponse, { contactId: string }>(DELETE_CRM_CONTACT);

    /* Contact profile (POGO-12603) */
    const GET_CONTACT_PROFILE = (contactId: string) =>
        useQuery<GetCrmContactProfileResponse, { contactId: string }>(GET_CRM_CONTACT_PROFILE, {
            variables: { contactId },
            skip: !contactId,
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const LIST_CONTACT_NOTES = (input: ListCrmContactNotesInput) =>
        useQuery<ListCrmContactNotesResponse, { input: ListCrmContactNotesInput }>(LIST_CRM_CONTACT_NOTES, {
            variables: { input },
            skip: !input.contactId,
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'network-only'
        });

    const ADD_CONTACT_NOTE = () => useMutation<AddCrmContactNoteResponse, { input: AddCrmContactNoteInput }>(ADD_CRM_CONTACT_NOTE);

    const SET_CONTACT_NOTE_PINNED = () =>
        useMutation<SetCrmContactNotePinnedResponse, { input: SetCrmContactNotePinnedInput }>(SET_CRM_CONTACT_NOTE_PINNED);

    /* Contacts screen (global list) */
    const LIST_ALL_CONTACTS = (input: ListAllCrmContactsInput, skip = false) =>
        useQuery<ListAllCrmContactsResponse, { input: ListAllCrmContactsInput }>(LIST_ALL_CRM_CONTACTS, {
            variables: { input },
            skip,
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    /* lazy contact search — the task contact picker (Wave 3 Phase 10) */
    const LIST_ALL_CONTACTS_LAZY = () =>
        useLazyQuery<ListAllCrmContactsResponse, { input: ListAllCrmContactsInput }>(LIST_ALL_CRM_CONTACTS);

    /* duplicate suggest + merge */
    const SUGGESTED_DUPLICATES = (accountId: string) =>
        useQuery<SuggestedCrmAccountDuplicatesResponse, { accountId: string }>(SUGGESTED_CRM_ACCOUNT_DUPLICATES, {
            variables: { accountId },
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const MERGE_ACCOUNTS = () => useMutation<MergeCrmAccountsResponse, { input: MergeCrmAccountsInput }>(MERGE_CRM_ACCOUNTS);

    const MARK_DUPLICATE = () =>
        useMutation<MarkCrmAccountDuplicateResponse, { input: MarkCrmAccountDuplicateInput }>(MARK_CRM_ACCOUNT_DUPLICATE);

    /* the database-wide Duplicates queue (POGO-12836) */
    const LIST_DUPLICATE_GROUPS = (input: ListCrmDuplicateGroupsInput) =>
        useQuery<ListCrmDuplicateGroupsResponse, { input: ListCrmDuplicateGroupsInput }>(LIST_CRM_DUPLICATE_GROUPS, {
            variables: { input },
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    /* email open/click tracking + manual composer (Phase 10) */
    const LIST_ACCOUNT_EMAILS = (accountId: string) =>
        useQuery<ListCrmAccountEmailsResponse, { accountId: string }>(LIST_CRM_ACCOUNT_EMAILS, {
            variables: { accountId },
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const SEND_EMAIL = () => useMutation<SendCrmEmailResponse, { input: SendCrmEmailInput }>(SEND_CRM_EMAIL);

    /* General Pogozo CRM email signature (POGO-13734) — company-wide singleton. */
    const GET_EMAIL_SETTINGS = () =>
        useQuery<GetCrmEmailSettingsResponse>(GET_CRM_EMAIL_SETTINGS, {
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const SAVE_EMAIL_SETTINGS = () =>
        useMutation<SaveCrmEmailSettingsResponse, { input: SaveCrmEmailSettingsInput }>(SAVE_CRM_EMAIL_SETTINGS);

    /* email templates (Phase 3) — simple / fancy, selectable in a campaign (Phase 8) */
    const LIST_EMAIL_TEMPLATES = () =>
        useQuery<ListCrmEmailTemplatesResponse>(LIST_CRM_EMAIL_TEMPLATES, {
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const GET_EMAIL_TEMPLATE = (id: string) =>
        useQuery<GetCrmEmailTemplateResponse, { id: string }>(GET_CRM_EMAIL_TEMPLATE, {
            variables: { id },
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const CREATE_EMAIL_TEMPLATE = () =>
        useMutation<CreateCrmEmailTemplateResponse, { input: CreateCrmEmailTemplateInput }>(CREATE_CRM_EMAIL_TEMPLATE);

    const UPDATE_EMAIL_TEMPLATE = () =>
        useMutation<UpdateCrmEmailTemplateResponse, { input: UpdateCrmEmailTemplateInput }>(UPDATE_CRM_EMAIL_TEMPLATE);

    const DELETE_EMAIL_TEMPLATE = () => useMutation<DeleteCrmEmailTemplateResponse, { id: string }>(DELETE_CRM_EMAIL_TEMPLATE);

    /** Clone a saved template into an editable "Copy of …" (POGO-13087). */
    const DUPLICATE_EMAIL_TEMPLATE = () =>
        useMutation<DuplicateCrmEmailTemplateResponse, { input: DuplicateCrmEmailTemplateInput }>(DUPLICATE_CRM_EMAIL_TEMPLATE);

    /** Side-effect-free test send of a saved template to a picked CMS user or free-text address. */
    const SEND_TEMPLATE_TEST_EMAIL = () =>
        useMutation<SendCrmTemplateTestEmailResponse, { input: SendCrmTemplateTestEmailInput }>(SEND_CRM_TEMPLATE_TEST_EMAIL);

    /* contract templates (POGO-13757 Phase 1) — admin-owned, global, {{Token}} body */
    const LIST_CONTRACT_TEMPLATES = (input: ListCrmContractTemplatesInput) =>
        useQuery<ListCrmContractTemplatesResponse, { input: ListCrmContractTemplatesInput }>(LIST_CRM_CONTRACT_TEMPLATES, {
            variables: { input },
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const GET_CONTRACT_TEMPLATE = (id: string) =>
        useQuery<GetCrmContractTemplateResponse, { id: string }>(GET_CRM_CONTRACT_TEMPLATE_DETAILS, {
            variables: { id },
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const CREATE_CONTRACT_TEMPLATE = () =>
        useMutation<CreateCrmContractTemplateResponse, { input: CreateCrmContractTemplateInput }>(CREATE_CRM_CONTRACT_TEMPLATE);

    const UPDATE_CONTRACT_TEMPLATE = () =>
        useMutation<UpdateCrmContractTemplateResponse, { input: UpdateCrmContractTemplateInput }>(UPDATE_CRM_CONTRACT_TEMPLATE);

    const ARCHIVE_CONTRACT_TEMPLATE = () =>
        useMutation<ArchiveCrmContractTemplateResponse, { templateId: string }>(ARCHIVE_CRM_CONTRACT_TEMPLATE);

    /* contract instances (POGO-13757 Phase 2) — baked draft filed on account + contact */
    const LIST_CONTRACTS = (input: ListCrmContractsInput) =>
        useQuery<ListCrmContractsResponse, { input: ListCrmContractsInput }>(LIST_CRM_CONTRACTS, {
            variables: { input },
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const GET_CONTRACT = (id: string) =>
        useQuery<GetCrmContractResponse, { id: string }>(GET_CRM_CONTRACT_DETAILS, {
            variables: { id },
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const CREATE_CONTRACT = () => useMutation<CreateCrmContractResponse, { input: CreateCrmContractInput }>(CREATE_CRM_CONTRACT);

    /* send for signature (POGO-13757 Phase 4) — promotes draft → sent, emails the contact */
    const SEND_CONTRACT = () =>
        useMutation<SendCrmContractResponse, { id: string; subject?: string; bodyHtml?: string }>(SEND_CRM_CONTRACT);

    /* signed-PDF download (POGO-13757 Phase 4) — lazy: fetch a fresh presigned URL on click */
    const GET_CONTRACT_SIGNED_PDF_URL = () =>
        useLazyQuery<GetCrmContractSignedPdfUrlResponse, { id: string }>(GET_CRM_CONTRACT_SIGNED_PDF_URL, {
            fetchPolicy: 'network-only'
        });

    /* merge tags (Phase 6) — the canonical catalog, one source of truth with the renderer */
    const MERGE_TAGS = () =>
        useQuery<CrmMergeTagsResponse>(CRM_MERGE_TAGS, {
            fetchPolicy: 'cache-first'
        });

    /* audiences (Phase 7) — saved board filters, consumed by Phase 8 campaigns */
    const LIST_AUDIENCES = () =>
        useQuery<ListCrmAudiencesResponse>(LIST_CRM_AUDIENCES, {
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const MEMBER_COUNTS = () =>
        useQuery<ListCrmAudienceMemberCountsResponse>(LIST_CRM_AUDIENCE_MEMBER_COUNTS, {
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const BOARD_STAGE_LABELS = () =>
        useQuery<ListCrmBoardStageLabelsResponse>(LIST_CRM_BOARD_STAGE_LABELS, {
            fetchPolicy: 'cache-and-network'
        });

    const GET_AUDIENCE = (id: string) =>
        useQuery<GetCrmAudienceResponse, { id: string }>(GET_CRM_AUDIENCE, {
            variables: { id },
            skip: !id,
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    /** Live member count + preview for the filter being built (before saving). */
    const PREVIEW_AUDIENCE = (filters?: CrmAudienceFiltersInput) =>
        useQuery<PreviewCrmAudienceResponse, { filters?: CrmAudienceFiltersInput }>(PREVIEW_CRM_AUDIENCE, {
            variables: { filters },
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const CREATE_AUDIENCE = () => useMutation<CreateCrmAudienceResponse, { input: CreateCrmAudienceInput }>(CREATE_CRM_AUDIENCE);

    const UPDATE_AUDIENCE = () => useMutation<UpdateCrmAudienceResponse, { input: UpdateCrmAudienceInput }>(UPDATE_CRM_AUDIENCE);

    const DELETE_AUDIENCE = () => useMutation<DeleteCrmAudienceResponse, { id: string }>(DELETE_CRM_AUDIENCE);

    /* campaigns (Phase 8) — email only: audience → template → compose → test → send/schedule */
    const LIST_CAMPAIGNS = () =>
        useQuery<ListCrmCampaignsResponse>(LIST_CRM_CAMPAIGNS, {
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const GET_CAMPAIGN = (id: string) =>
        useQuery<GetCrmCampaignResponse, { id: string }>(GET_CRM_CAMPAIGN, {
            variables: { id },
            skip: !id,
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const GET_CAMPAIGN_RECIPIENTS = () =>
        useLazyQuery<GetCrmCampaignRecipientsResponse, { campaignId: string }>(GET_CRM_CAMPAIGN_RECIPIENTS, {
            fetchPolicy: 'network-only'
        });

    const CREATE_CAMPAIGN = () => useMutation<CreateCrmCampaignResponse, { input: CreateCrmCampaignInput }>(CREATE_CRM_CAMPAIGN);

    const UPDATE_CAMPAIGN = () => useMutation<UpdateCrmCampaignResponse, { input: UpdateCrmCampaignInput }>(UPDATE_CRM_CAMPAIGN);

    const DELETE_CAMPAIGN = () => useMutation<DeleteCrmCampaignResponse, { id: string }>(DELETE_CRM_CAMPAIGN);

    const SCHEDULE_CAMPAIGN = () => useMutation<ScheduleCrmCampaignResponse, { input: ScheduleCrmCampaignInput }>(SCHEDULE_CRM_CAMPAIGN);

    const SEND_CAMPAIGN_NOW = () => useMutation<SendCrmCampaignNowResponse, { campaignId: string }>(SEND_CRM_CAMPAIGN_NOW);

    const SEND_TEST_EMAIL = () => useMutation<SendCrmTestEmailResponse, { input: SendCrmTestEmailInput }>(SEND_CRM_TEST_EMAIL);

    const ADD_CAMPAIGN_RECIPIENT = () =>
        useMutation<AddCrmCampaignRecipientResponse, { input: AddCrmCampaignRecipientInput }>(ADD_CRM_CAMPAIGN_RECIPIENT);

    const SEND_CAMPAIGN_TO_TARGET = () =>
        useMutation<SendCrmCampaignToTargetResponse, { input: SendCrmCampaignTargetInput }>(SEND_CRM_CAMPAIGN_TO_TARGET);

    /* export */
    const EXPORT_BOARD = () => useLazyQuery<ExportCrmBoardResponse, { filter?: CrmAccountFilterInput }>(EXPORT_CRM_BOARD);

    /* automations */
    const LIST_AUTOMATIONS = () =>
        useQuery<ListCrmAutomationsResponse>(LIST_CRM_AUTOMATIONS, {
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const CREATE_AUTOMATION = () => useMutation<CreateCrmAutomationResponse, { input: CreateCrmAutomationInput }>(CREATE_CRM_AUTOMATION);

    const UPDATE_AUTOMATION = () => useMutation<UpdateCrmAutomationResponse, { input: UpdateCrmAutomationInput }>(UPDATE_CRM_AUTOMATION);

    const DELETE_AUTOMATION = () => useMutation<DeleteCrmAutomationResponse, { id: string }>(DELETE_CRM_AUTOMATION);

    /** Clone a saved automation into an editable DRAFT copy (POGO-13087). */
    const DUPLICATE_AUTOMATION = () =>
        useMutation<DuplicateCrmAutomationResponse, { input: DuplicateCrmAutomationInput }>(DUPLICATE_CRM_AUTOMATION);

    /** Side-effect-free test fire — delivers comms to the recipient, simulates data-mutating steps (POGO-13087). */
    const TEST_AUTOMATION = () => useMutation<TestCrmAutomationResponse, { input: TestCrmAutomationInput }>(TEST_CRM_AUTOMATION);

    const ENROL_IN_AUTOMATION = () =>
        useMutation<EnrolCrmInAutomationResponse, { input: EnrolCrmInAutomationInput }>(ENROL_CRM_IN_AUTOMATION);

    /* public lead-capture forms (Phase 6) */
    const LIST_FORMS = () =>
        useQuery<ListCrmFormsResponse>(LIST_CRM_FORMS, {
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const LIST_FORM_SUBMISSIONS = (variables: { formId?: string; contactId?: string }, skip = false) =>
        useQuery<ListCrmFormSubmissionsResponse>(LIST_CRM_FORM_SUBMISSIONS, {
            variables,
            skip,
            fetchPolicy: 'network-only'
        });

    const CREATE_FORM = () => useMutation<CreateCrmFormResponse, { input: CreateCrmFormInput }>(CREATE_CRM_FORM);

    const UPDATE_FORM = () => useMutation<UpdateCrmFormResponse, { input: UpdateCrmFormInput }>(UPDATE_CRM_FORM);

    const DELETE_FORM = () => useMutation<DeleteCrmFormResponse, { id: string }>(DELETE_CRM_FORM);

    /* Pipedrive CSV import (Phase 9) */
    const PREVIEW_IMPORT = () =>
        useLazyQuery<PreviewPipedriveCsvResponse, { input: PreviewPipedriveCsvInput }>(PREVIEW_PIPEDRIVE_CSV, {
            fetchPolicy: 'network-only'
        });

    const RUN_PIPEDRIVE_IMPORT = () => useMutation<ImportPipedriveCsvResponse, { input: ImportPipedriveCsvInput }>(IMPORT_PIPEDRIVE_CSV);

    /* Contact-first CSV import (POGO-13223) */
    const PREVIEW_CONTACTS_IMPORT = () =>
        useLazyQuery<PreviewContactsCsvResponse, { input: PreviewContactsCsvInput }>(PREVIEW_CONTACTS_CSV, {
            fetchPolicy: 'network-only'
        });

    const RUN_CONTACTS_IMPORT = () => useMutation<ImportContactsCsvResponse, { input: ImportContactsCsvInput }>(IMPORT_CONTACTS_CSV);

    /* tasks (Phase 8) */
    const LIST_TASKS = (input?: ListCrmTasksInput) =>
        useQuery<ListCrmTasksResponse, { input?: ListCrmTasksInput }>(LIST_CRM_TASKS, {
            variables: { input },
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const CREATE_TASK = () => useMutation<CreateCrmTaskResponse, { input: CreateCrmTaskInput }>(CREATE_CRM_TASK);

    const UPDATE_TASK = () => useMutation<UpdateCrmTaskResponse, { input: UpdateCrmTaskInput }>(UPDATE_CRM_TASK);

    const COMPLETE_TASK = () => useMutation<CompleteCrmTaskResponse, { taskId: string }>(COMPLETE_CRM_TASK);

    const DELETE_TASK = () => useMutation<DeleteCrmTaskResponse, { taskId: string; scope?: CrmTaskScopeOption }>(DELETE_CRM_TASK);

    /* Booking-link Google connection (POGO-13214 Phase 1) — separate connection with disconnect */
    const GET_BOOKING_GOOGLE_CONNECTION = () =>
        useQuery<GetCrmBookingGoogleConnectionResponse>(GET_CRM_BOOKING_GOOGLE_CONNECTION, {
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const GET_BOOKING_GOOGLE_AUTH_URL = () =>
        useLazyQuery<GetCrmBookingGoogleAuthUrlResponse>(GET_CRM_BOOKING_GOOGLE_AUTH_URL, { fetchPolicy: 'network-only' });

    const DISCONNECT_BOOKING_GOOGLE = () => useMutation<DisconnectCrmBookingGoogleResponse>(DISCONNECT_CRM_BOOKING_GOOGLE);

    /* Team-member schedule (POGO-13214 Phase 2) — weekly working hours + timezone */
    const GET_MY_SCHEDULE = () =>
        useQuery<GetMyCrmScheduleResponse>(GET_MY_CRM_SCHEDULE, {
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const SAVE_MY_SCHEDULE = () => useMutation<SaveMyCrmScheduleResponse, { input: SaveCrmScheduleInput }>(SAVE_MY_CRM_SCHEDULE);

    /* Booking calendar page (POGO-13214) — an admin picks a user and edits that user's schedule */
    const GET_SCHEDULE_FOR_ADMIN = (adminId: string) =>
        useQuery<GetCrmScheduleForAdminResponse, { adminId: string }>(GET_CRM_SCHEDULE_FOR_ADMIN, {
            variables: { adminId },
            skip: !adminId,
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const LIST_SCHEDULES = () =>
        useQuery<ListCrmSchedulesResponse>(LIST_CRM_SCHEDULES, {
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const SAVE_SCHEDULE_FOR_ADMIN = () =>
        useMutation<SaveCrmScheduleForAdminResponse, { adminId: string; input: SaveCrmScheduleInput }>(SAVE_CRM_SCHEDULE_FOR_ADMIN);

    /* Admin blocks (POGO-13214) — company-wide unavailable periods on the calendar */
    const LIST_ADMIN_BLOCKS = () =>
        useQuery<ListCrmAdminBlocksResponse>(LIST_CRM_ADMIN_BLOCKS, {
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const CREATE_ADMIN_BLOCK = () => useMutation<CreateCrmAdminBlockResponse, { input: CreateCrmAdminBlockInput }>(CREATE_CRM_ADMIN_BLOCK);

    const UPDATE_ADMIN_BLOCK = () => useMutation<UpdateCrmAdminBlockResponse, { input: UpdateCrmAdminBlockInput }>(UPDATE_CRM_ADMIN_BLOCK);

    const DELETE_ADMIN_BLOCK = () => useMutation<DeleteCrmAdminBlockResponse, { id: string }>(DELETE_CRM_ADMIN_BLOCK);

    // Delete a recurring block and all following occurrences (POGO-13267).
    const DELETE_ADMIN_BLOCK_SERIES = () =>
        useMutation<{ deleteCrmAdminBlockSeries: number }, { seriesId: string; fromStartAt: string }>(DELETE_CRM_ADMIN_BLOCK_SERIES);

    /* Meeting types (POGO-13214 Phase 3) — staff CRUD over the object a booking link exposes */
    const LIST_MEETING_TYPES = () =>
        useQuery<ListCrmMeetingTypesResponse>(LIST_CRM_MEETING_TYPES, {
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const LIST_MEETING_HOSTS = () =>
        useQuery<ListCrmMeetingHostsResponse>(LIST_CRM_MEETING_HOSTS, {
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    /* Assignable staff (POGO-13408) — CRM-scoped, uncapped staff list behind the
       automation assignee and Tasks owner pickers (replaces the SUPER_ONLY
       admin-management getAdminList). */
    const LIST_ASSIGNABLE_STAFF = () =>
        useQuery<ListCrmAssignableStaffResponse>(CRM_ASSIGNABLE_STAFF, {
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const CREATE_MEETING_TYPE = () =>
        useMutation<CreateCrmMeetingTypeResponse, { input: CreateCrmMeetingTypeInput }>(CREATE_CRM_MEETING_TYPE);

    const UPDATE_MEETING_TYPE = () =>
        useMutation<UpdateCrmMeetingTypeResponse, { input: UpdateCrmMeetingTypeInput }>(UPDATE_CRM_MEETING_TYPE);

    const ARCHIVE_MEETING_TYPE = () => useMutation<ArchiveCrmMeetingTypeResponse, { id: string }>(ARCHIVE_CRM_MEETING_TYPE);

    const DELETE_MEETING_TYPE = () => useMutation<DeleteCrmMeetingTypeResponse, { id: string }>(DELETE_CRM_MEETING_TYPE);

    /* Booking links (POGO-13214 Phase 4) — staff CRUD over the shareable slug */
    const LIST_BOOKING_LINKS = () =>
        useQuery<ListCrmBookingLinksResponse>(LIST_CRM_BOOKING_LINKS, {
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const CREATE_BOOKING_LINK = () =>
        useMutation<CreateCrmBookingLinkResponse, { input: CreateCrmBookingLinkInput }>(CREATE_CRM_BOOKING_LINK);

    const UPDATE_BOOKING_LINK = () =>
        useMutation<UpdateCrmBookingLinkResponse, { input: UpdateCrmBookingLinkInput }>(UPDATE_CRM_BOOKING_LINK);

    const DELETE_BOOKING_LINK = () => useMutation<DeleteCrmBookingLinkResponse, { id: string }>(DELETE_CRM_BOOKING_LINK);

    /* Meetings agenda + attendance (POGO-13214 Phase 8; POGO-13309) */
    // MeetingScope values match the API's CrmMeetingListScope GraphQL enum 1:1
    // (both lower-case), so the scope passes straight through as the variable.
    const LIST_MEETINGS = (scope: MeetingScope) =>
        useQuery<ListCrmMeetingsResponse, { scope: MeetingScope }>(LIST_CRM_MEETINGS, {
            variables: { scope },
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const LIST_MEETINGS_IN_RANGE = (from: string, to: string) =>
        useQuery<ListCrmMeetingsInRangeResponse, { from: string; to: string }>(LIST_CRM_MEETINGS_IN_RANGE, {
            variables: { from, to },
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const LIST_GOOGLE_EVENTS = (from: string, to: string, adminIds: string[]) =>
        useQuery<ListCrmGoogleEventsResponse, { from: string; to: string; adminIds: string[] }>(LIST_CRM_GOOGLE_EVENTS, {
            variables: { from, to, adminIds },
            skip: adminIds.length === 0,
            fetchPolicy: 'cache-and-network'
        });

    const GET_CALENDAR_SETTINGS = () => useQuery<GetCrmCalendarSettingsResponse>(GET_CRM_CALENDAR_SETTINGS);

    const SAVE_CALENDAR_SETTINGS = () =>
        useMutation<SaveCrmCalendarSettingsResponse, { input: SaveCrmCalendarSettingsInput }>(SAVE_CRM_CALENDAR_SETTINGS);

    const MARK_MEETING_ATTENDANCE = () => {
        const [mutate, result] = useMutation<MarkCrmMeetingAttendanceResponse, { bookingId: string; attendance: string }>(
            MARK_CRM_MEETING_ATTENDANCE
        );
        // GraphQL expects the enum *key* (ATTENDED/DNA); callers keep passing the
        // lowercase value, so uppercase it at send time. (POGO-13861)
        const run = ({ variables }: { variables: { bookingId: string; attendance: 'attended' | 'dna' } }) =>
            mutate({ variables: { ...variables, attendance: variables.attendance.toUpperCase() } });
        return [run, result] as const;
    };

    const CANCEL_MEETING = () => useMutation<CancelCrmMeetingResponse, { bookingId: string }>(CANCEL_CRM_MEETING);

    // Cancel a recurring meeting and all following occurrences (POGO-13267).
    const CANCEL_MEETING_SERIES = () =>
        useMutation<{ cancelCrmMeetingSeries: number }, { seriesId: string; fromStartAt: string }>(CANCEL_CRM_MEETING_SERIES);

    const RESCHEDULE_MEETING = () =>
        useMutation<RescheduleCrmMeetingResponse, { bookingId: string; startAt: string }>(RESCHEDULE_CRM_MEETING);

    const SET_MEETING_NOTE = () => useMutation<SetCrmMeetingNoteResponse, { bookingId: string; note: string }>(SET_CRM_MEETING_NOTE);

    const UPDATE_MEETING_ATTENDEES = () =>
        useMutation<UpdateCrmMeetingAttendeesResponse, { input: UpdateCrmMeetingAttendeesInput }>(UPDATE_CRM_MEETING_ATTENDEES);

    const PLACE_MEETING = () => useMutation<PlaceCrmMeetingResponse, { input: PlaceCrmMeetingInput }>(PLACE_CRM_MEETING);

    const REPLACE_MEETING = () => useMutation<ReplaceCrmMeetingResponse, { input: ReplaceCrmMeetingInput }>(REPLACE_CRM_MEETING);

    /* reporting (Phase 11) */
    const WIN_LOSS_BY_OWNER = (filter?: CrmReportFilterInput) =>
        useQuery<CrmWinLossByOwnerResponse, { filter?: CrmReportFilterInput }>(CRM_WIN_LOSS_BY_OWNER, {
            variables: { filter },
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    const STAGE_CONVERSION = (filter?: CrmReportFilterInput) =>
        useQuery<CrmStageConversionResponse, { filter?: CrmReportFilterInput }>(CRM_STAGE_CONVERSION, {
            variables: { filter },
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network'
        });

    return {
        GET_PIPELINE,
        LIST_PIPELINES,
        UPDATE_PIPELINE,
        GET_TAGS,
        CREATE_TAG,
        RENAME_TAG,
        DELETE_TAG,
        GET_LEAD_SOURCES,
        CREATE_LEAD_SOURCE,
        RENAME_LEAD_SOURCE,
        DELETE_LEAD_SOURCE,
        LIST_BOARDS,
        GET_JOURNEY_BOARD,
        LIST_ENROLLMENTS,
        CREATE_BOARD,
        UPDATE_BOARD,
        REORDER_BOARDS,
        SET_BOARD_STATUS,
        DELETE_BOARD,
        CREATE_PIPELINE,
        UPDATE_BOARD_PIPELINE,
        REORDER_PIPELINES,
        PLACE_AUTOMATION,
        PLACE_ON_BOARD,
        GET_BOARD,
        LIST_ACCOUNTS,
        LIST_ACCOUNTS_LAZY,
        BUSINESS_DETAIL_OPTIONS,
        GET_ACCOUNT,
        CREATE_ACCOUNT,
        DELETE_ACCOUNT,
        UPDATE_ACCOUNT,
        MOVE_ACCOUNT_STAGE,
        ADD_NOTE,
        EDIT_NOTE,
        DELETE_NOTE,
        LINK_BUSINESS,
        SET_POGOZO_DEMO,
        SET_REPORTING_EXCLUDED,
        REQUEST_BUSINESS_LOGIN_MUTATION,
        VERIFY_BUSINESS_LOGIN_MUTATION,
        REQUEST_STATUS_CHANGE_MUTATION,
        VERIFY_STATUS_CHANGE_MUTATION,
        REQUEST_FORCE_DELETE_MUTATION,
        VERIFY_FORCE_DELETE_MUTATION,
        GET_BUSINESS_LOGIN_LOG,
        LIST_CONTACTS,
        CREATE_CONTACT,
        UPDATE_CONTACT,
        SET_PRIMARY_CONTACT,
        SET_CONTACT_EMAIL_SUBSCRIBED,
        DELETE_CONTACT,
        LIST_ALL_CONTACTS,
        LIST_ALL_CONTACTS_LAZY,
        GET_CONTACT_PROFILE,
        LIST_CONTACT_NOTES,
        ADD_CONTACT_NOTE,
        SET_CONTACT_NOTE_PINNED,
        SUGGESTED_DUPLICATES,
        MERGE_ACCOUNTS,
        MARK_DUPLICATE,
        LIST_DUPLICATE_GROUPS,
        LIST_ACCOUNT_EMAILS,
        SEND_EMAIL,
        GET_EMAIL_SETTINGS,
        SAVE_EMAIL_SETTINGS,
        LIST_EMAIL_TEMPLATES,
        GET_EMAIL_TEMPLATE,
        CREATE_EMAIL_TEMPLATE,
        UPDATE_EMAIL_TEMPLATE,
        DELETE_EMAIL_TEMPLATE,
        DUPLICATE_EMAIL_TEMPLATE,
        SEND_TEMPLATE_TEST_EMAIL,
        LIST_CONTRACT_TEMPLATES,
        GET_CONTRACT_TEMPLATE,
        CREATE_CONTRACT_TEMPLATE,
        UPDATE_CONTRACT_TEMPLATE,
        ARCHIVE_CONTRACT_TEMPLATE,
        LIST_CONTRACTS,
        GET_CONTRACT,
        CREATE_CONTRACT,
        SEND_CONTRACT,
        GET_CONTRACT_SIGNED_PDF_URL,
        MERGE_TAGS,
        LIST_AUDIENCES,
        MEMBER_COUNTS,
        BOARD_STAGE_LABELS,
        GET_AUDIENCE,
        PREVIEW_AUDIENCE,
        CREATE_AUDIENCE,
        UPDATE_AUDIENCE,
        DELETE_AUDIENCE,
        LIST_CAMPAIGNS,
        GET_CAMPAIGN,
        GET_CAMPAIGN_RECIPIENTS,
        CREATE_CAMPAIGN,
        UPDATE_CAMPAIGN,
        DELETE_CAMPAIGN,
        SCHEDULE_CAMPAIGN,
        SEND_CAMPAIGN_NOW,
        SEND_TEST_EMAIL,
        ADD_CAMPAIGN_RECIPIENT,
        SEND_CAMPAIGN_TO_TARGET,
        EXPORT_BOARD,
        LIST_AUTOMATIONS,
        CREATE_AUTOMATION,
        UPDATE_AUTOMATION,
        DELETE_AUTOMATION,
        DUPLICATE_AUTOMATION,
        TEST_AUTOMATION,
        ENROL_IN_AUTOMATION,
        LIST_FORMS,
        LIST_FORM_SUBMISSIONS,
        CREATE_FORM,
        UPDATE_FORM,
        DELETE_FORM,
        PREVIEW_IMPORT,
        RUN_PIPEDRIVE_IMPORT,
        PREVIEW_CONTACTS_IMPORT,
        RUN_CONTACTS_IMPORT,
        LIST_TASKS,
        CREATE_TASK,
        UPDATE_TASK,
        COMPLETE_TASK,
        DELETE_TASK,
        GET_BOOKING_GOOGLE_CONNECTION,
        GET_BOOKING_GOOGLE_AUTH_URL,
        DISCONNECT_BOOKING_GOOGLE,
        GET_MY_SCHEDULE,
        SAVE_MY_SCHEDULE,
        GET_SCHEDULE_FOR_ADMIN,
        LIST_SCHEDULES,
        SAVE_SCHEDULE_FOR_ADMIN,
        LIST_ADMIN_BLOCKS,
        CREATE_ADMIN_BLOCK,
        UPDATE_ADMIN_BLOCK,
        DELETE_ADMIN_BLOCK,
        DELETE_ADMIN_BLOCK_SERIES,
        LIST_MEETING_TYPES,
        LIST_MEETING_HOSTS,
        LIST_ASSIGNABLE_STAFF,
        CREATE_MEETING_TYPE,
        UPDATE_MEETING_TYPE,
        ARCHIVE_MEETING_TYPE,
        DELETE_MEETING_TYPE,
        LIST_BOOKING_LINKS,
        CREATE_BOOKING_LINK,
        UPDATE_BOOKING_LINK,
        DELETE_BOOKING_LINK,
        LIST_MEETINGS,
        LIST_MEETINGS_IN_RANGE,
        LIST_GOOGLE_EVENTS,
        GET_CALENDAR_SETTINGS,
        SAVE_CALENDAR_SETTINGS,
        MARK_MEETING_ATTENDANCE,
        CANCEL_MEETING,
        CANCEL_MEETING_SERIES,
        RESCHEDULE_MEETING,
        SET_MEETING_NOTE,
        UPDATE_MEETING_ATTENDEES,
        PLACE_MEETING,
        REPLACE_MEETING,
        WIN_LOSS_BY_OWNER,
        STAGE_CONVERSION
    };
};

export default useGQL;
